import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Library: A Hub for Knowledge and Learning');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI Library, offering a vast collection of resources, quiet study spaces, and a conducive environment for academic growth and research excellence.`
        });
    }

}
